module.exports = __webpack_public_path__ + "img/w-admin_area.a7596b87.png";